import EditBenefit from './EditBenefit'

export default EditBenefit
